import { render, staticRenderFns } from "./gatewaypositionmodal.vue?vue&type=template&id=cfdb4e02&scoped=true"
var script = {}
import style0 from "./gatewaypositionmodal.vue?vue&type=style&index=0&id=cfdb4e02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdb4e02",
  null
  
)

export default component.exports